import {takeLatestF, putAll} from '@fl/cmsch-fe-library';
import {uniqBy} from 'lodash/fp';
import {SagaIterator} from 'redux-saga';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {simpleAnimalBrowserSelector} from 'app/animal-browser/model/selector';
import {cabFilterFormName} from 'app/animal-browser/types/cab-filter-form-values';
import {t} from 'app/translations';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {animalBrowserAction, GetDistrictCodesOptionsAction} from '../action';

const tt = t('animalBrowser');

function* execute({payload}: GetDistrictCodesOptionsAction): SagaIterator {
    const selectedValues = (yield* select(formHelpers.formValues(cabFilterFormName))).prop('districtCodes').orElse([]);
    const oldOptions = (yield* select(simpleAnimalBrowserSelector.districtCodesOptions)).orElse([]);
    const selectedOptions = oldOptions.filter(option => selectedValues.includes(option.value));

    yield* put(animalBrowserAction.setLoading('districtCodesSearch', true));

    const response = yield* call(Api.getCabDistrictsAutocompleteList, {text: payload});
    if (response.isSuccess) {
        const options = response.data.map(option => ({
            value: option.code,
            label: `${option.internalCode ? `${option.internalCode} - ` : ''}${option.name}`,
        }));
        yield* put(animalBrowserAction.getDistrictCodesOptionsSuccess(
            uniqBy('value', [...selectedOptions, ...options],
            )));
    } else {
        yield putAll(showBeError(response, tt('filter')));
    }

    yield* put(animalBrowserAction.setLoading('districtCodesSearch', false));
}

/**
 * Loads district-code autocomplete options for the comprehensive filters.
 *
 * @returns The saga watcher for district-code option requests.
 */
export function* getDistrictCodesOptionsSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_DISTRICT_CODES_OPTIONS', execute);
}
